export default __webpack_public_path__ + "assets/cart-fill-component.2a41da02.svg";